export default function toLowerCase(v:string):string {
    return v[0].toLocaleLowerCase() + v.substring(1, v.length);
}
